import React from 'react';
import { GenericDetailPage } from '../../../components/generic';
import { useAppStatus, AppStatus } from './useData';
import { moduleConfig, getDetailSections, getStatusBadges } from './config';

const Detail: React.FC = () => {
  return (
    <GenericDetailPage<AppStatus>
      useData={useAppStatus}
      config={{
        ...moduleConfig,
        getDetailSections,
        getStatusBadges,
      }}
    />
  );
};

export default Detail;
